import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const AnaTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type AnaTabType = keyof typeof AnaTab;

const AnaBooking = observer(() => {
  const history = useHistory();
  const [anaBookingTab, setAnaBookingTab] = useState<AnaTabType>(
    (utils.getParam('ana_booking_type') as AnaTabType) ||
      (utils.getParam('ana_booking_tab') as AnaTabType) ||
      'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'ANA_BOOKING');
    if (!currentParams.has('ana_booking_type')) {
      currentParams.set('ana_booking_type', anaBookingTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, anaBookingTab]);

  const handleTabChange = useCallback(
    (tab: AnaTabType) => {
      setAnaBookingTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'ANA_BOOKING');
      currentParams.set('ana_booking_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={AnaTab} currentTab={anaBookingTab} onChange={handleTabChange} />
      {anaBookingTab === 'TOTAL' ? <Total /> : <Items />}
    </>
  );
});

export default AnaBooking;
